module.exports = __webpack_public_path__ + "img/tourial-blog-m.0b3311cb.png";